import { cn } from "@/lib/utils";

interface PageHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  description?: string
  /** Hiển thị cạnh tiêu đề (vd badge account type) */
  badge?: React.ReactNode
}

export function PageHeader({
  title,
  description,
  badge,
  children,
  className,
  ...props
}: PageHeaderProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-start justify-between gap-4 md:flex-row md:items-center",
        className
      )}
      {...props}
    >
      <div>
        <div className="flex items-center gap-2.5">
          <h1 className="text-2xl font-bold">{title}</h1>
          {badge}
        </div>
        {description && <p className="text-muted-foreground">{description}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
